import { isEmpty } from "lodash";
import React from "react";
import { AvatarChip, AvatarChipPerson } from "../../../../../../avatar-chip";
import { useUpdateEventSearchFilters } from "../../../../hooks/event-search-filters/useUpdateEventSearchFilters";
import { GQLEventSearchBlock } from "../../../../utils/types";
import { BaseChip } from "./BaseChip";
import { convertEnumToPascalCase } from "./convertEnumToPascalCase";

export type GQLAttendeeFilter = NonNullable<GQLEventSearchBlock["attendeeFilter"]>;

export const AttendeeFilter = ({
  attendeeFilter,
  eventSearchBlockId,
  conversationId,
  disabled = false,
}: {
  attendeeFilter: GQLAttendeeFilter;
  eventSearchBlockId: string;
  conversationId: string;
  disabled?: boolean;
}) => {
  const { updateAttendeeFilter } = useUpdateEventSearchFilters();

  const onDelete = (type: "resolvedAttendees" | "unresolvedAttendees") => () => {
    updateAttendeeFilter(eventSearchBlockId, conversationId, type, []);
  };

  const showResolved = !isEmpty(attendeeFilter.resolvedAttendees);
  const showUnresolved = !isEmpty(attendeeFilter.unresolvedAttendees);

  const modifier = attendeeFilter.modifier;
  const resolvedAttendeesAsAvatarChipPersons: AvatarChipPerson[] = attendeeFilter.resolvedAttendees.map(
    (attendee) => {
      return {
        id: attendee.id,
        isYou: attendee.isYou,
        userId: attendee.userId,
        primaryEmail: attendee.primaryEmail,
        profile: attendee.profile,
      };
    },
  );
  const unresolvedAttendees = attendeeFilter.unresolvedAttendees
    .map((unresolved) => `"${unresolved}"`)
    .join(", ");

  const unresolvedAttendeeComponent = (
    <>
      <span className="cw-text-subtle">{convertEnumToPascalCase(modifier)}</span>{" "}
      {unresolvedAttendees}
    </>
  );

  if (!showResolved && !showUnresolved) {
    return null;
  }

  return (
    <>
      {showResolved && (
        <AvatarChip
          persons={resolvedAttendeesAsAvatarChipPersons}
          sentiment="neutral"
          variant="outlined"
          leadingText={convertEnumToPascalCase(modifier)}
          onDelete={onDelete("resolvedAttendees")}
          disabled={disabled}
        />
      )}
      {showUnresolved && (
        <BaseChip disabled={disabled} onDelete={onDelete("unresolvedAttendees")}>
          {unresolvedAttendeeComponent}
        </BaseChip>
      )}
    </>
  );
};
